import { useState } from "react";
import clsx from "clsx";
import Button from "./Button";

export interface ImageInfoProps {}

export function ImageInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Toggle button */}
      <div className="flex gap-2">
        <button
          className="text-[12px] underline decoration-solid text-gray-extra-dark"
          onClick={toggleModal}
        >
          Pravna obavijest
        </button>
      </div>
      {/* Overlay background */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 cursor-pointer bg-opacity-35 bg-gray-extra-dark"
          onClick={toggleModal}
        />
      )}

      {/* Drawer */}
      {isOpen && (
        <div
          className={clsx(
            "flex flex-col mx-auto rounded gap-5 left-1/2 -translate-x-1/2 fixed top-1/2 -translate-y-1/2 w-[350px] sm:w-[650px] md:w-[740px] bg-white z-50 transform transition-transform duration-300"
          )}
        >
          <div className="flex justify-between px-10 pt-10">
            <h1 className="text-lg font-bold uppercase sm:text-2xl">
              PRAVNE INFORMACIJE
            </h1>
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={toggleModal}
              className="cursor-pointer"
            >
              <path
                d="M1 0.711121L17 15.2889"
                stroke="#ABABAB"
                strokeWidth="1.5"
              />
              <path
                d="M17 0.711121L1 15.2889"
                stroke="#ABABAB"
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <hr className="w-full border-t-1 border-extra-light" />
          <span className="flex gap-2 px-10 text-[14px] sm:text-[16px] text-gray-extra-dark text-opacity-80">
            Cijene, opis, oprema i tehnički podaci informativnog su karaktera.
            Iskazane preporučene maloprodajne cijene u eurima uključuju PDV i
            posebni porez (trošarinu) kod vozila koja su u obvezi plaćanja
            posebnog poreza na motorna vozila. Navedeni podaci o potrošnji
            goriva i emisiji CO2 u skladu su s homologacijom WLTP (uredba
            E2017/948). Fotografije su ilustrativnog karaktera, za više
            informacija kontaktirajte ovlaštenog Citroën distributera. C
            AUTOMOBIL IMPORT D.O.O. i ovlašteni Citroën distributeri ne snose
            nikakvu odgovornost.
          </span>
          <hr className="w-full border-t-1 border-extra-light" />
          <div className="flex justify-end px-10 pb-10">
            <Button
              text={"Zatvorite"}
              variant={"primary"}
              size={"base"}
              className="flex"
              action={toggleModal}
            ></Button>
          </div>
        </div>
      )}
    </>
  );
}

export default ImageInfo;
